import { render, staticRenderFns } from "./ContatoApresentacao.vue?vue&type=template&id=e0f077b2&"
import script from "./ContatoApresentacao.vue?vue&type=script&lang=js&"
export * from "./ContatoApresentacao.vue?vue&type=script&lang=js&"
import style0 from "./ContatoApresentacao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
